<template>
	<div class="membermanagement">
		<a-layout id="components-layout-demo-side" style="min-height: 100vh">
			<menuBar :current="current" :openKeys="openKeys"></menuBar>
			<a-layout style="overflow: auto;">
				<topBar :fatherMethod="initialize"></topBar>
				<a-layout-content style="margin: 16px; min-width: 1192px;">
					<div style="font-size: 20px;line-height: 30px;margin-bottom: 10px;font-weight: 700;padding-left: 8px;">会员管理</div>
					<div class="contentcard">
						<div style="font-size: 14px; font-weight: 700;">搜索会员</div>
						<a-divider dashed style="margin: 10px 0;" />
						<div style="margin-bottom: 20px;">
							<div style="margin-bottom: 20px;">
								<div style="display: inline-block;">
									<span style="font-size: 14px; font-weight: 700;display: inline-block;min-width: 60px;">微信昵称</span>
									<a-input placeholder="请输入微信昵称" style="width: 260px;margin-left: 5px;margin-right: 40px;" v-model="searchlist.nick_name" />
								</div>
								<div style="display: inline-block;">
									<span style="font-size: 14px; font-weight: 700;display: inline-block;min-width: 60px;">微信号</span>
									<a-input disabled placeholder="请输入微信号" style="width: 260px;margin-left: 5px;margin-right: 40px;" v-model="searchlist.wx_name" />
								</div>
								<div style="display: inline-block;">
									<span style="font-size: 14px; font-weight: 700;display: inline-block;min-width: 60px;">手机号</span>
									<a-input placeholder="请输入手机号" style="width: 260px;margin-left: 5px;margin-right: 40px;" v-model="searchlist.phone_number" />
								</div>
								<div style="display: inline-block;margin-top: 20px;">
									<span style="font-size: 14px; font-weight: 700;display: inline-block;min-width: 60px;">ID</span>
									<a-input placeholder="请输入ID" style="width: 260px;margin-left: 5px;margin-right: 40px;" v-model="searchlist.id" />
								</div>
							</div>
						</div>
						<div style="text-align: center;">
							<a-button type="primary" style="width: 96px;" @click="searchbtn">搜索</a-button>
						</div>
					</div>
					<div class="contentcard">
						<div style="padding-bottom: 50px;">
							<div>
								<div v-if="!memberlist.length">
									<a-alert message="查询结果为空" banner type="info" />
								</div>
								<div v-if="memberlist.length">
									<a-row type="flex" justify="space-around" align="middle" style="background-color: #f3f3f5;font-size: 14px;height: 60px;font-weight: 700;">
										<a-col :span="2" style="text-align: center;">ID</a-col>
										<a-col :span="2" style="text-align: center;">微信昵称</a-col>
										<a-col :span="2" style="text-align: center;">微信头像</a-col>
										<!-- <a-col :span="3" style="text-align: center;">微信号</a-col> -->
										<a-col :span="2" style="text-align: center;">手机号</a-col>
										<a-col :span="2" style="text-align: center;">会员等级</a-col>
										<a-col :span="3" style="text-align: center;">有效期</a-col>
										<a-col :span="2" style="text-align: center;">历史消费金额</a-col>
										<!-- <a-col :span="2" style="text-align: center;">现有积分</a-col> -->
										<a-col :span="5" style="text-align: center;">操作</a-col>
									</a-row>
								</div>
								<div style="color: #666;font-size: 14px;" v-for="member in memberlist" :key="member.id">
									<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px 0;">
										<a-col :span="2" style="text-align: center;">{{member.id}}</a-col>
										<a-col :span="2" style="text-align: center;">
											<a-popover trigger="hover">
												<template slot="content">
													<p>{{app_search(member.user_from_app)}}</p>
												</template>
												{{member.nick_name}}
											</a-popover>
										</a-col>
										<a-col :span="2" style="text-align: center;"><img :src="member.avatar_url" height="56"></a-col>
										<a-col :span="2" style="text-align: center;">{{member.phone_number}}</a-col>
										<a-col :span="2" style="text-align: center;">{{member_status[member.member_level]}}</a-col>
										<a-col :span="3" style="text-align: center;" v-if="member.timebuttonstatus==0">{{validity_time(member.validity_time)}}
											<a-button type="link" size="small" style="font-size: 12px;padding: 0;margin-left: 5px;" @click="()=>{member.timebuttonstatus=1}">修改</a-button>
										</a-col>
										<a-col :span="3" style="text-align: center;" v-if="member.timebuttonstatus==1">
											<a-date-picker :showToday="false" @change="changevaliditytime($event,member)">
												<template slot="renderExtraFooter">
													<a @click="changetoperpetual(member)">永久</a>
												</template>
												<a>{{ member.validity_time=='perpetual' ? '永久' : member.validity_time }}</a>
											</a-date-picker>
											<a-button type="link" size="small" style="font-size: 12px;padding: 0;margin-left: 5px;" @click="savebtn(member)">保存</a-button>
										</a-col>
										<a-col :span="2" style="text-align: center;">￥{{member.sumprice/100}}</a-col>
										<!-- <a-col :span="2" style="text-align: center;">现有积分</a-col> -->
										<a-col :span="5" style="text-align: center;" v-if="member.buttonstatus==0">
											<!-- <a-button ghost type="primary" size="small" style="font-size: 12px;width: 96px;" @click="()=>{member.buttonstatus=1}">修改等级</a-button>
											<a-button ghost type="primary" size="small" style="font-size: 12px;width: 96px;" @click="creditbtn(member)">积分管理</a-button> -->
											<!-- <a-button ghost type="primary" size="small" style="font-size: 12px;width: 96px;" >设为店主</a-button> -->
											<a-button type="link" size="small" style="font-size: 12px;padding: 0;" @click="()=>{member.buttonstatus=1}">修改等级</a-button>
											<span style="font-size: 12px;padding: 0;">|</span>
											<a-button type="link" size="small" style="font-size: 12px;padding: 0;" @click="creditbtn(member)">积分管理</a-button>
											<span style="font-size: 12px;padding: 0;" v-if="member.member_level==1||member.member_level==2">|</span>
											<a-button type="link" size="small" style="font-size: 12px;padding: 0;" @click="modifyagency(member)" v-if="member.member_level==1||member.member_level==2">代理修改</a-button>
										</a-col>
										<a-col :span="5" style="text-align: center;" v-if="member.buttonstatus==1">
											<a-select :defaultValue="member.member_level" style="width: 120px" @change="changememberlevel($event,member)">
												<a-select-option :value="1">会员</a-select-option>
												<a-select-option :value="2">VIP会员</a-select-option>
												<a-select-option :value="3" disabled>钻石会员</a-select-option>
												<a-select-option :value="4" disabled>皇冠会员</a-select-option>
											</a-select>
											<a-button type="primary" size="small" style="font-size: 12px;width: 96px;" @click="savebtn(member)">保存</a-button>
											<!-- <a-button type="primary" size="small" style="font-size: 12px;width: 96px;" @click="creditbtn(member)">积分管理</a-button> -->
										</a-col>

									</a-row>
								</div>
							</div>
							<div style="float: right;position: relative;bottom: -18px;">
								<a-pagination showSizeChanger @showSizeChange="onShowSizeChange" :current="endpage/pageSize" :pageSize="pageSize" :total="membersum"
								 showQuickJumper @change="pageChange" />
							</div>
						</div>
					</div>
				</a-layout-content>
				<bottomBar></bottomBar>
			</a-layout>
		</a-layout>
		<div>
			<a-back-top />
		</div>
		
		<a-modal title="代理修改" :visible="bianjivisible" @ok="bianjiOk" :confirmLoading="confirmLoading" @cancel="bianjiCancel">
			<div class="newcategory"><span class="newcategorytext">代理ID</span>
				<a-input style="width: 250px;" v-model="bianjiagency.agency_user_id" placeholder="请输入代理ID" />
			</div>
			<div class="newcategory"><span class="newcategorytext">绑定状态</span>
				<!-- <a-input style="width: 250px;" v-model="bianjiagency.bind_status" placeholder="请选择绑定状态" /> -->
				<a-select v-model="bianjiagency.bind_status" style="width: 250px" placeholder="请选择绑定状态">
					<a-select-option :value="1">接洽中</a-select-option>
					<a-select-option :value="2">下单中</a-select-option>
					<a-select-option :value="3">已绑定</a-select-option>
				</a-select>
			</div>
			
		</a-modal>
		
	</div>
</template>

<script>
	export default {

		data() {
			return {
				current: ['membermanagement'],
				openKeys: [''],
				searchlist: {
					nick_name: null,
					wx_name: null,
					phone_number: null,
					id: null,
				},
				memberlist: [],
				membersum: 0,
				app_list: [],
				startpage: this.$route.query.startpage || 0,
				endpage: this.$route.query.endpage || 10,
				pageSize: Number(this.$route.query.pageSize) || 10,
				member_status: {
					'1': '会员',
					'2': 'VIP会员',
					'3': '钻石会员',
					'4': '皇冠会员',
				},
				bianjivisible:false,
				confirmLoading:false,
				bianjiagency:{
					user_id:null,
					agency_user_id:null,
					bind_status:null
				}
				
			}
		},
		created: function() {
			if (this.$route.query.searchlist) {
				this.searchlist = JSON.parse(this.$route.query.searchlist);
			}
			this.initialize();
		},
		methods: {
			initialize() {
				var self = this;
				var params = {
					searchlist: this.searchlist,
					startpage: this.startpage,
					pageSize: this.pageSize,
					apps_id: this.$store.state.now_app_state,
				};
				this.$axios.get('/member/get', {
					params: params
				}).then(function(res) {
					self.app_list = res.data.applist;
					for (var i = 0; i < res.data.memberlist.length; i++) {
						var sumprice = 0;
						if (res.data.memberlist[i].TC_Trades.length > 0) {
							for (var j = 0; j < res.data.memberlist[i].TC_Trades.length; j++) {
								if (res.data.memberlist[i].TC_Trades[j].status != 'to_be_paid' || res.data.memberlist[i].TC_Trades[j].status !=
									'close') {
									sumprice += res.data.memberlist[i].TC_Trades[j].receipt_price
								}
							}
						}
						res.data.memberlist[i].sumprice = sumprice;
						res.data.memberlist[i].buttonstatus = 0;
						res.data.memberlist[i].timebuttonstatus = 0;
					}
					self.memberlist = res.data.memberlist;
					self.membersum = res.data.membersum;

				});
			},
			onShowSizeChange(current, pageSize) {
				this.pageSize = pageSize;
				this.startpage = this.pageSize * (current - 1);
				this.endpage = this.pageSize * current;
				this.initialize();
				this.$router.push({
					name: 'membermanagement',
					query: {
						pageSize: this.pageSize,
						startpage: this.startpage,
						endpage: this.endpage,
						searchlist: JSON.stringify(this.searchlist)
					}
				})

			},
			pageChange(pageNumber) {
				this.startpage = this.pageSize * (pageNumber - 1);
				this.endpage = this.pageSize * pageNumber;
				this.initialize();
				this.$router.push({
					name: 'membermanagement',
					query: {
						pageSize: this.pageSize,
						startpage: this.startpage,
						endpage: this.endpage,
						searchlist: JSON.stringify(this.searchlist)
					}
				})
			},
			searchbtn() {
				this.startpage = 0;
				this.endpage = this.pageSize;
				// this.pageSize = 10;
				this.initialize();
				this.$router.push({
					name: 'membermanagement',
					query: {
						pageSize: this.pageSize,
						startpage: this.startpage,
						endpage: this.endpage,
						searchlist: JSON.stringify(this.searchlist)
					}
				})
			},
			changememberlevel(ev, member) {
				member.member_level = ev;
			},
			changevaliditytime(ev, member) {
				member.validity_time = ev.format('YYYY-MM-DD')
				// console.log(ev, member)
			},
			changetoperpetual(member) {
				member.validity_time = 'perpetual'
			},
			app_search(app_id) {
				// console.log(this.app_list);
				// console.log(app_id);
				// return "ceshi"
				for (var i = 0; i < this.app_list.length; i++) {
					if (app_id == this.app_list[i].id) {
						return this.app_list[i].app_name
					}
				}
			},
			savebtn(member) {
				var self = this;
				this.$confirm({
					title: '提示',
					content: '是否保存会员等级修改',
					okText: '确认',
					cancelText: '取消',
					onOk() {
						member.buttonstatus = 0;
						var params = {
							id: member.id,
							member_level: member.member_level,
							validity_time: member.validity_time
						}
						self.$axios.post('/member/update', {
							params: params
						}).then(function(res) {
							self.$notification.open({
								message: '通知',
								description: res.data,
								onClose: close,
							});
							self.initialize();
						})
					},
					onCancel() {},
				});
			},
			gotodetails(id) {
				this.$router.push({
					name: 'salesdetails',
					query: {
						id: id
					}
				})
			},
			creditbtn(member) {
				this.$router.push({
					name: 'creditmanagement',
					query: {
						id: member.id,
						user_from_app: member.user_from_app
					}
				})
			},
			validity_time(validity_time) {
				if (validity_time == 'perpetual') {
					return "永久"
				} else {
					return validity_time
				}
			},
			modifyagency(member) {
				this.bianjiagency.user_id = member.id;
				if(!member.UIC_Ams_User_Agencies.length){
					this.bianjiagency.agency_user_id = null;
					this.bianjiagency.bind_status = null;
				}else{
					this.bianjiagency.agency_user_id = member.UIC_Ams_User_Agencies[0].agency_user_id||null;
					this.bianjiagency.bind_status = member.UIC_Ams_User_Agencies[0].bind_status||null;
				}
				this.bianjivisible = true;
			},
			bianjiOk(e) {
				var self = this;
				this.confirmLoading = true;
				this.$confirm({
					title: '提示',
					content: '是否保存修改',
					okText: '确认',
					cancelText: '取消',
					onOk() {
						self.$axios.post('/member/modifyagency', {
							params: {
								agency: self.bianjiagency
							}
						}).then(function(res) {
							self.$notification.open({
								message: '通知',
								description: res.data,
								onClose: close,
							});
							self.confirmLoading = false;
							if (res.data == '代理修改成功') {
								self.bianjivisible = false;
								self.initialize();
							}
						});
					},
					onCancel() {
						self.confirmLoading = false;
					},
				});
			},
			bianjiCancel(e) {
				this.bianjivisible = false;
			},


		},

	};
</script>

<style>
	.membermanagement .contentcard {
		padding: 24px;
		background-color: #fff;
		border-radius: 5px;
		margin-bottom: 20px;
		position: relative;
	}
	
	.newcategory {
		margin-bottom: 10px;
		position: relative;
	}
	
	.newcategory .newcategorytext {
		position: relative;
		width: 100px;
		font-weight: 700;
		display: inline-block;
	}
</style>



// WEBPACK FOOTER //
// index.vue?4d1806c0